import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import './css/DownloadButton.css';

const DownloadButton = ({
    fileName,
    transcriptId,
    buttonLabel = "Download",
    className = "btn btn-info text-light mx-2"
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedFormats, setSelectedFormats] = useState([]);

    const formats = [
        { value: 'xml', label: 'XML', extension: 'xml' },
        { value: 'stm', label: 'STM', extension: 'stm' },
        { value: 'txt', label: 'TXT', extension: 'txt' },
        { value: 'srt', label: 'SRT', extension: 'srt' },
        { value: 'docx', label: 'DOCX', extension: 'docx' },
        { value: 'textgrid', label: 'TextGrid', extension: 'TextGrid' }
    ];

    const toggleFormat = (formatValue) => {
        setSelectedFormats(prev =>
            prev.includes(formatValue)
                ? prev.filter(f => f !== formatValue)
                : [...prev, formatValue]
        );
    };

    const toggleSelectAll = () => {
        if (selectedFormats.length === formats.length) {
            setSelectedFormats([]);
        } else {
            setSelectedFormats(formats.map(f => f.value));
        }
    };

    const handleDownload = (format) => {
        try {
            const extension = formats.find(f => f.value === format)?.extension || format;
            const downloadFileName = fileName.replace(/\.[^/.]+$/, `.${extension}`);
            const urlToDownload = `${process.env.REACT_APP_STUDIO_URL}/transcript/download?id=${transcriptId}&format=${format}`;

            const link = document.createElement('a');
            link.href = urlToDownload;
            link.download = downloadFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download file. Please try again.');
        }
    };

    const handleDownloadSelected = () => {
        if (selectedFormats.length === 0) {
            alert('Please select at least one format to download.');
            return;
        }

        if (selectedFormats.length === 1) {
            handleDownload(selectedFormats[0]);
        } else {
            // Download as ZIP
            try {
                const baseFileName = fileName.replace(/\.[^/.]+$/, '');
                const urlToDownload = `${process.env.REACT_APP_STUDIO_URL}/transcript/download?id=${transcriptId}&format=${selectedFormats.join(',')}`;
                const link = document.createElement('a');
                link.href = urlToDownload;
                link.download = `${baseFileName}.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('ZIP download failed:', error);
                alert('Failed to download ZIP file. Please try again.');
            }
        }

        setSelectedFormats([]);
        setShowDropdown(false);
    };

    const allSelected = selectedFormats.length === formats.length;

    return (
        <Dropdown show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
            <Dropdown.Toggle
                className={className}
            >
                {buttonLabel}
            </Dropdown.Toggle>
            <Dropdown.Menu className="download-dropdown-menu">
                {/* Select All Option */}
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleSelectAll();
                    }}
                    className="download-checkbox-item"
                >
                    <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleSelectAll}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <strong>Select All</strong>
                </div>

                <Dropdown.Divider />

                {/* Individual File Format Options */}
                {formats.map((format) => (
                    <div
                        key={format.value}
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleFormat(format.value);
                        }}
                        className="download-checkbox-item"
                    >
                        <input
                            type="checkbox"
                            checked={selectedFormats.includes(format.value)}
                            onChange={() => toggleFormat(format.value)}
                            onClick={(e) => e.stopPropagation()}
                        />
                        {format.label}
                    </div>
                ))}

                <Dropdown.Divider />

                {/* Download Button */}
                <div className="download-button-container">
                    <button
                        onClick={handleDownloadSelected}
                        disabled={selectedFormats.length === 0}
                        className={`download-selected-button ${selectedFormats.length > 0 ? 'enabled' : 'disabled'}`}
                    >
                        Download Selected ({selectedFormats.length})
                    </button>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default DownloadButton;
